import "select2/dist/js/select2.full.min";

function initGreySelect() {

    $('.grey-select select').each((index, select) => {
        $(select).select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: 'grey-select-dropdown',
            placeholder: {
                id: "-1",
                text: $(select).attr('data-placeholder'),
                selected:'selected'
            },
        });
    });

}

export default initGreySelect;